type Handler<T = unknown> = (payload: T) => void;
const listeners = new Map<string, Set<Handler>>();

export function emit<T>(event: string, payload?: T): void {
  listeners.get(event)?.forEach((h) => h(payload));
}

export function on<T>(event: string, handler: Handler<T>): () => void {
  if (!listeners.has(event)) listeners.set(event, new Set());
  listeners.get(event)!.add(handler as Handler);
  return () => listeners.get(event)?.delete(handler as Handler);
}

// Known events (whitelist — keep in sync with emit/on call sites):
//
// Analytics events (consumed in features/analytics):
//   'filter:applied'   { active_filter_count, layer, matched_count }
//   'preset:selected'  { preset_id }
//   'layer:changed'    { from, to }
//   'poi:toggled'      { category, on }
//   'comune:opened'    { istat, source }
//   'place:selected'   { level, total_selected }
//   'auth:login'       { method }
//   'share:clicked'    { url_length }
//
// Performance events (emitted from main.tsx via web-vitals):
//   'web_vital'        { name: 'LCP' | 'INP' | 'CLS', value: number }
//
// Map control events (consumed in features/places/FlyToListener):
//   'places:flyToPoint'      { lat, lon, zoom? }
//   'places:flyToBounds'     { points: Array<{lat, lon}> }
//   'places:flyToSelection'  void
